import { useQuery } from "@tanstack/react-query";
import ApiClient from "../client";
import { ENDPOINTS } from "../endpoints";
import { SearchServicesFilters } from "../types";
import { queryKeys } from "../keys";


const client = new ApiClient(process.env.API_URL!, "app");

// Queries
export const useSearchServices = (
    filters: SearchServicesFilters,
    enabled = true
) =>
    useQuery({
        queryKey: queryKeys.searchServices(filters),
        queryFn: () => {
            const params = new URLSearchParams();
            Object.entries(filters).forEach(([key, value]) => {
                if (value !== undefined) {
                    params.append(key, value.toString());
                }
            });
            return client.get(`${ENDPOINTS.SEARCH_SERVICES}?${params}`);
        },
        enabled,
    });

export const useFindPathViaPoints = (
    startCode: string,
    endCode: string,
    viaPoints: string[] = [],
    enabled = true
) =>
    useQuery({
        queryKey: queryKeys.searchPath(startCode, endCode, viaPoints),
        queryFn: () => {
            const params = new URLSearchParams({ start: startCode, end: endCode });
            if (viaPoints.length > 0) {
                params.append("via", viaPoints.join(","));
            }
            return client.get(`${ENDPOINTS.SEARCH_PATH}?${params}`);
        },
        enabled: enabled && !!startCode && !!endCode,
    });
